export const PAYMENT_FAILED_CREDIT_CARD_DECLINED = 'payment_failed_credit_card_declined';
export const PAYMENT_FAILED_CREDIT_CARD_INSUFFICIENT_BALANCE = 'payment_failed_credit_card_insufficient_balance';
export const PAYMENT_FAILED_CREDIT_CARD_EXPIRED = 'payment_failed_credit_card_expired';
export const PAYMENT_FAILED_POINTS_INSUFFICIENT_BALANCE = 'payment_failed_points_insufficient_balance';
export const REFUND_FAILED_CREDIT_CARD_EXPIRED = 'refund_failed_credit_card_expired';
export const INVENTORY_UNAVAILABLE = 'hotel_reservation_failed_inventory_unavailable';

export const POLL_TIMEOUT = 'POLL_TIMEOUT';
export const UNEXPECTED = 'unexpected';
